import { useAppStore } from "@/lib/store";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

const MODELS = [
  // Claude
  { value: "claude-sonnet-4-5", label: "Claude 4.5 Sonnet" },
  // OpenAI (legacy)
  { value: "gpt-4o-mini", label: "GPT 4o-mini" },
  { value: "gpt-4.1-mini", label: "GPT 4.1-mini" },
  { value: "gpt-4o", label: "GPT 4o" },
  { value: "gpt-5-mini", label: "GPT 5-mini" },
] as const;

export function ModelSelector() {
  const { selectedModel, setSelectedModel } = useAppStore();

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-medium text-muted-foreground whitespace-nowrap">Model:</span>
      <Select value={selectedModel} onValueChange={setSelectedModel}>
        <SelectTrigger className="h-7 w-[110px] text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {MODELS.map((model) => (
            <SelectItem key={model.value} value={model.value} className="text-xs py-2">
              <span className="text-xs font-medium">{model.label}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
